import { render, staticRenderFns } from "./secondary-kpi-tab.vue?vue&type=template&id=6130a92a"
import script from "./secondary-kpi-tab.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-tab.vue?vue&type=script&lang=ts"
import style0 from "./secondary-kpi-tab.vue?vue&type=style&index=0&id=6130a92a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6130a92a')) {
      api.createRecord('6130a92a', component.options)
    } else {
      api.reload('6130a92a', component.options)
    }
    module.hot.accept("./secondary-kpi-tab.vue?vue&type=template&id=6130a92a", function () {
      api.rerender('6130a92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-tab.vue"
export default component.exports